import type {
    CapKeyEntityObject,
    CapKeyQueryParams,
} from "src/app/features/EmvKernelProfile/subFeatures/CapKey/services/server/CapKeyQueryTypes";
import { getAssignedDataGroup } from "../../../../../../../core/router/auth";
import { ResourceName, ResourceVariant } from "../../../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../../../core/service/baseApi";
import type { Dto } from "../../../../../../../core/types/be/Dto";
import type { CapKeyEntity } from "../../types/CapKeyEntity";
import { CapKeyDtoToEntity } from "../mappers/CapKeyDtoToEntity";
import { CapKeyEntityToDto } from "../mappers/CapKeyEntityToDto";

const CapKeyApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        CapKeyLoad: builder.query<CapKeyEntity, CapKeyQueryParams>({
            providesTags: [ResourceName.CAP_KEYS],
            query: (capKeyQueryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.EMV_KERNEL_PROFILES}/${ResourceVariant.APAC}/${capKeyQueryParams.emvKernelProfileId}/${ResourceName.CAP_KEYS}/${capKeyQueryParams.id}`,

                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return CapKeyDtoToEntity(response);
            },
        }),
        CapKeySave: builder.mutation<CapKeyEntity, CapKeyEntityObject>({
            query: (capKeyEntityObject) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.EMV_KERNEL_PROFILES}/${ResourceVariant.APAC}/${capKeyEntityObject.capKeyQuery.emvKernelProfileId}/${ResourceName.CAP_KEYS}`;
                const method = "POST";

                const body = CapKeyEntityToDto(capKeyEntityObject.capKeyFormData);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.CAP_KEYS],
        }),
        CapKeyUpdate: builder.mutation<CapKeyEntity, CapKeyEntityObject>({
            query: (capKeyEntityObject) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.EMV_KERNEL_PROFILES}/${ResourceVariant.APAC}/${capKeyEntityObject.capKeyQuery.emvKernelProfileId}/${ResourceName.CAP_KEYS}/${capKeyEntityObject.capKeyQuery.id}`;
                const method = "PUT";

                const body = CapKeyEntityToDto(capKeyEntityObject.capKeyFormData);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.CAP_KEYS],
        }),
        CapKeyDelete: builder.mutation<CapKeyEntity, CapKeyQueryParams>({
            query: (capKeyQueryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.EMV_KERNEL_PROFILES}/${ResourceVariant.APAC}/${capKeyQueryParams.emvKernelProfileId}/${ResourceName.CAP_KEYS}/${capKeyQueryParams.id}`,
                    method: "DELETE",
                };
            },
            invalidatesTags: [ResourceName.CAP_KEYS],
        }),
    }),
});

export const { useLazyCapKeyLoadQuery, useCapKeySaveMutation, useCapKeyUpdateMutation, useCapKeyDeleteMutation } = CapKeyApi;
